export const STAT_TYPES = {
  PERFORMANCE: 'PERFORMANCE',
  QUOTA: 'QUOTA',
  QUESTIONS: 'QUESTIONS',
}

export const statsOptions = [
  STAT_TYPES.PERFORMANCE,
  STAT_TYPES.QUOTA,
  STAT_TYPES.QUESTIONS,
]
